import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-conditional-dimension',
  templateUrl: './help-add-conditional-dimension.component.html',
  styleUrls: ['./help-add-conditional-dimension.component.scss']
})
export class HelpAddConditionalDimensionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
